import React from "react";
import { Link } from "react-router-dom";
import AbouImg from "../Assest/images/ceo.jpeg";
import AbouImg1 from "../Assest/images/about-banner.jpg";
import AbouImg2 from "../Assest/images/cms-banner2.jpg";

const AboutUs = () => {
  return (
    <div className="page-wrapper">
      <div className="cover-bg-img">
        <div className="dz-bnr-inr-entry">
          <h1>About Us</h1>
          <nav aria-label="breadcrumb" className="breadcrumb-row">
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb-item">About Us</li>
            </ul>
          </nav>
        </div>
      </div>

      <div className="container">
        <div className="py-5">
          <div className="row">
            <div className="col-lg-5">
              <div className="about-media">
                <img src={AbouImg1} className="w-100" alt="" />
              </div>
            </div>
            <div className="col-lg-7 ps-lg-5 ps-3 pt-lg-0 pt-3">
              <span className="text-primary-1 d-block mb-3">About us :</span>
              <h2 className="">PRAANSH – INFRASTRUCTURE & PRESENCE</h2>
              <p>
                Praansh Healthcare, a unit of Together Ventures Limited (TGVL),
                is a leading name in the eye-care vertical across Delhi NCR.
                Equipped with world-class Carl Zeiss diagnostic and surgical
                systems, Praansh offers highly accurate, technology-driven
                ophthalmic evaluations. With over 30 years of surgical
                experience and a consistent record of zero complications,
                Praansh has earned a trusted reputation among patients and
                partner institutions alike. The clinic is strategically located
                on the main road with excellent metro connectivity and remains
                open on Sundays, ensuring easy accessibility for all residents.
                In addition to clinical excellence, Praansh has established
                strong partnerships with premium eyewear and lens suppliers,
                enabling comprehensive eye-care solutions under one roof.
              </p>

              <div className="ceo-profile">
                <div className="ceo-media">
                  <img src={AbouImg} alt="" />
                </div>
                <div className="ceo-content">
                  <h6 className="mb-1">Tarun Bansal</h6>
                  <p className="mb-0">Founder & CEO </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="get-in-touch">
        <div class="m-r100 m-md-r0 m-sm-r0">
          <h3 class="dz-title mb-lg-0 mb-3">
            Questions ?
            <span>
              Our experts will help find the grar that’s right for you
            </span>
          </h3>
        </div>
        <a href="./contact-us" class="btn btn-light bg-primary1">
          Get In Touch
        </a>
      </section>
      {/* our-team */}
      <section className="py-5">
        <div className="featured-header">
          <div className="featured-header-inner">
            <h2 className="featured-title">Our Teams</h2>
            <p className="featured-subtitle">
              Popular Products Popular Products Description
            </p>
          </div>
        </div>
        <div className="container">
          <div className="facility-box">
            <div className="row">
              <div className="col-lg-5 align-self-center">
                <div className="facitlity-media">
                  {/* Experience Box */}
                  <div className="experience-box">
                    <h2>15+</h2>
                    <p>
                      Years of
                      <br />
                      Experience
                    </p>
                  </div>

                  <img src={AbouImg2} className="w-100" alt="Eye Checkup" />
                </div>
              </div>

              <div className="col-lg-7 ps-lg-5 ps-3 pt-lg-0 pt-3">
                <div className="facitlity-media-content">
                  <div>
                    <h5 className="fw-bold mb-1">Dr. Manju Bansal</h5>
                    <small className="mb-2 d-block">
                      (Senior Consultant, Eye Surgeon)
                    </small>
                    <p className="text-primary-1 fw-bold">
                      MBBS, MS (Ophthalmology)
                    </p>
                  </div>
                  <div
                    className="timing-box
                      "
                  >
                    <h2 className="product-title">Timings</h2>
                    <ul className="d-flex align-items-center flex-wrap mb-0">
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-clock"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        8:00 am to 6:00 pm
                      </li>
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-calendar"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          ></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        (Mon, Tue, Wed, Thu, Fri, Sat,Sun)
                      </li>
                      <li className="text-danger">
                        {" "}
                        <sub>Sunday:(Also)</sub>{" "}
                      </li>
                    </ul>
                  </div>
                  <div
                    className="facilites-box
                      "
                  >
                    <ul className="">
                      <li>Computerised Eye Testing</li>
                      <li>Glaucoma Treatment & Surgery</li>
                      <li>Cataract Surgery (PHACO) – Starts From Rs. 3,000</li>
                      <li>Medical Retina</li>
                      <li>Eyelid Treatment</li>
                      <li>Orthoptic Treatment</li>
                      <li>Contact Lens Clinic</li>
                      <li>
                        Lasik Surgery (Spectacles Removal) – Starts From Rs.
                        25,000
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <hr />
            {/* dr.parshant */}
            <div className="row mt-lg-5 mb-5">
              <div className="col-lg-7 ">
                <div className="facitlity-media-content">
                  <div>
                    <h5 className="fw-bold mb-1">Dr. Prashant Yadav</h5>
                    <small className="mb-2 d-block">(Dermatologist)</small>
                    <p className="text-primary-1 fw-bold">
                      MBBS, MS (Dermatology)
                    </p>
                    <small className="mb-2 d-block">
                      Consultation Fees: <b>₹500/-</b>{" "}
                    </small>
                  </div>
                  <div
                    className="timing-box
                      "
                  >
                    <h2 className="product-title">Timings</h2>
                    <ul className="d-flex align-items-center flex-wrap mb-0">
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-clock"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        10:00 am to 12:00 pm
                      </li>
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-calendar"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          ></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        (Tue, Thu, Sat)
                      </li>
                      <li className="text-danger">
                        {" "}
                        <sub>Sunday: 10:00 am to 12:00 pm</sub>{" "}
                      </li>
                    </ul>
                  </div>
                  <div
                    className="facilites-box
                      "
                  >
                    <ul className="">
                      <li>Computerised Eye Testing</li>
                      <li>Glaucoma Treatment & Surgery</li>
                      <li>Cataract Surgery (PHACO) – Starts From Rs. 3,000</li>
                      <li>Medical Retina</li>
                      <li>Eyelid Treatment</li>
                      <li>Orthoptic Treatment</li>
                      <li>Contact Lens Clinic</li>
                      <li>
                        Lasik Surgery (Spectacles Removal) – Starts From Rs.
                        25,000
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 ps-lg-5 ps-3 pt-lg-0 pt-3 align-self-center">
                <div className="facitlity-media">
                  {/* Experience Box */}
                  <div className="experience-box experience-box-1">
                    <h2>15+</h2>
                    <p>
                      Years of
                      <br />
                      Experience
                    </p>
                  </div>

                  <img src={AbouImg2} className="w-100" alt="Eye Checkup" />
                </div>
              </div>
            </div>
            {/* dr.parshant */}
            <hr />
            {/* dr getanjali */}
            <div className="row">
              <div className="col-lg-5 align-self-center">
                <div className="facitlity-media">
                  {/* Experience Box */}
                  <div className="experience-box">
                    <h2>15+</h2>
                    <p>
                      Years of
                      <br />
                      Experience
                    </p>
                  </div>

                  <img src={AbouImg2} className="w-100" alt="Eye Checkup" />
                </div>
              </div>

              <div className="col-lg-7 ps-lg-5 ps-3 pt-lg-0 pt-3">
                <div className="facitlity-media-content">
                  <div>
                    <h5 className="fw-bold mb-1">DR. Geetanjali</h5>
                    <small className="mb-2 d-block">(Dentist)</small>
                    <p className="text-primary-1 fw-bold">
                      {" "}
                      BDS , MDS (Dentist)
                    </p>
                    <small className="mb-2 d-block">
                      Consultation Fees: <b>₹200/-</b>{" "}
                    </small>
                  </div>
                  <div
                    className="timing-box
                      "
                  >
                    <h2 className="product-title">Timings</h2>
                    <ul className="d-flex align-items-center flex-wrap mb-0">
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-clock"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        10:00 am to 8:00 pm
                      </li>
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-calendar"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          ></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        (Mon, Tue, Thu, Fri, Sat)
                      </li>
                      <li className="text-danger">
                        {" "}
                        <sub>Sunday: 10:00 am to 2:00 pm</sub>{" "}
                      </li>
                    </ul>
                  </div>
                  <div
                    className="facilites-box
                      "
                  >
                    <ul className="">
                      <li>Computerised Eye Testing</li>
                      <li>Glaucoma Treatment & Surgery</li>
                      <li>Cataract Surgery (PHACO) – Starts From Rs. 3,000</li>
                      <li>Medical Retina</li>
                      <li>Eyelid Treatment</li>
                      <li>Orthoptic Treatment</li>
                      <li>Contact Lens Clinic</li>
                      <li>
                        Lasik Surgery (Spectacles Removal) – Starts From Rs.
                        25,000
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            {/* dr */}
            <div className="row mt-lg-5 mb-5">
              <div className="col-lg-7">
                <div className="facitlity-media-content">
                  <div>
                    <h5 className="fw-bold mb-1">Dr. Manoj Birla</h5>
                    <small className="mb-2 d-block">(General Medicine)</small>
                    <p className="text-primary-1 fw-bold">
                      MBBS, MD (Medicine)
                    </p>
                    <small className="mb-2 d-block">
                      Consultation Fees: <b>₹500/-</b>{" "}
                    </small>
                  </div>
                  <div
                    className="timing-box
                      "
                  >
                    <h2 className="product-title">Timings</h2>
                    <ul className="d-flex align-items-center flex-wrap mb-0">
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-clock"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        10:00 am to 12:00 pm
                      </li>
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-calendar"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          ></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        (Tue, Thu, Sat)
                      </li>
                      <li className="text-danger">
                        {" "}
                        <sub>Sunday: 10:00 am to 12:00 pm</sub>{" "}
                      </li>
                    </ul>
                  </div>
                  <div
                    className="facilites-box
                      "
                  >
                    <ul className="">
                      <li>Computerised Eye Testing</li>
                      <li>Glaucoma Treatment & Surgery</li>
                      <li>Cataract Surgery (PHACO) – Starts From Rs. 3,000</li>
                      <li>Medical Retina</li>
                      <li>Eyelid Treatment</li>
                      <li>Orthoptic Treatment</li>
                      <li>Contact Lens Clinic</li>
                      <li>
                        Lasik Surgery (Spectacles Removal) – Starts From Rs.
                        25,000
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 ps-lg-5 ps-3 pt-lg-0 pt-3 align-self-center">
                <div className="facitlity-media">
                  {/* Experience Box */}
                  <div className="experience-box experience-box-1">
                    <h2>15+</h2>
                    <p>
                      Years of
                      <br />
                      Experience
                    </p>
                  </div>

                  <img src={AbouImg2} className="w-100" alt="Eye Checkup" />
                </div>
              </div>
            </div>
<hr />
 <div className="row mt-lg-5 mb-5">
            
              <div className="col-lg-5  align-self-center">
                <div className="facitlity-media">
                  {/* Experience Box */}
                  <div className="experience-box">
                    <h2>15+</h2>
                    <p>
                      Years of
                      <br />
                      Experience
                    </p>
                  </div>

                  <img src={AbouImg2} className="w-100" alt="Eye Checkup" />
                </div>
              </div>
  <div className="col-lg-7 ps-lg-5 ps-3 pt-lg-0 pt-3">
                <div className="facitlity-media-content">
                  <div>
                    <h5 className="fw-bold mb-1">Dr. S. Ranjan</h5>
                    <small className="mb-2 d-block">(Physician)</small>
                    <p className="text-primary-1 fw-bold">
                      MBBS (General Physician)
                    </p>
                    <small className="mb-2 d-block">
                      Consultation Fees: <b>₹1000/-</b>{" "}
                    </small>
                  </div>
                  <div
                    className="timing-box
                      "
                  >
                    <h2 className="product-title">Timings</h2>
                    <ul className="d-flex align-items-center flex-wrap mb-0">
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-clock"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                       10:00 AM – 8:00 PM
                      </li>
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-calendar"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          ></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        ( Monday to Saturday:)
                      </li>
                      <li className="text-danger">
                        {" "}
                        <sub> Wednesday: Off</sub>{" "}
                      </li>
                    </ul>
                  </div>
                  <div
                    className="facilites-box
                      "
                  >
                    <ul className="">
                      <li>Computerised Eye Testing</li>
                      <li>Glaucoma Treatment & Surgery</li>
                      <li>Cataract Surgery (PHACO) – Starts From Rs. 3,000</li>
                      <li>Medical Retina</li>
                      <li>Eyelid Treatment</li>
                      <li>Orthoptic Treatment</li>
                      <li>Contact Lens Clinic</li>
                      <li>
                        Lasik Surgery (Spectacles Removal) – Starts From Rs.
                        25,000
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
<hr />
 <div className="row mt-lg-5 mb-5">
              <div className="col-lg-7">
                <div className="facitlity-media-content">
                  <div>
                    <h5 className="fw-bold mb-1">Dr. Nitish Khare</h5>
                    <small className="mb-2 d-block">(General Medicine)</small>
                    <p className="text-primary-1 fw-bold">
                      MBBS, MD (Medicine)
                    </p>
                    <small className="mb-2 d-block">
                      Consultation Fees: <b>₹500/-</b>{" "}
                    </small>
                  </div>
                  <div
                    className="timing-box
                      "
                  >
                    <h2 className="product-title">Timings</h2>
                    <ul className="d-flex align-items-center flex-wrap mb-0">
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-clock"
                        >
                          <circle cx="12" cy="12" r="10"></circle>
                          <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                       By Appointment Only
                      </li>
                      <li className="me-lg-3 mb-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather me-2 feather-calendar"
                        >
                          <rect
                            x="3"
                            y="4"
                            width="18"
                            height="18"
                            rx="2"
                            ry="2"
                          ></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        (Available Every Day – By Appointment Only)
                      </li>
                      <li className="text-danger">
                        {" "}
                        <sub>Available Every Day </sub>{" "}
                      </li>
                    </ul>
                  </div>
                  <div
                    className="facilites-box
                      "
                  >
                    <ul className="">
                      <li>Computerised Eye Testing</li>
                      <li>Glaucoma Treatment & Surgery</li>
                      <li>Cataract Surgery (PHACO) – Starts From Rs. 3,000</li>
                      <li>Medical Retina</li>
                      <li>Eyelid Treatment</li>
                      <li>Orthoptic Treatment</li>
                      <li>Contact Lens Clinic</li>
                      <li>
                        Lasik Surgery (Spectacles Removal) – Starts From Rs.
                        25,000
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 ps-lg-5 ps-3 pt-lg-0 pt-3 align-self-center">
                <div className="facitlity-media">
                  {/* Experience Box */}
                  <div className="experience-box experience-box-1">
                    <h2>15+</h2>
                    <p>
                      Years of
                      <br />
                      Experience
                    </p>
                  </div>

                  <img src={AbouImg2} className="w-100" alt="Eye Checkup" />
                </div>
              </div>
            </div>
<hr />
          </div>
        </div>
      </section>

      {/* our-services */}

      <section className="py-lg-5 py-3 bg-light">
        <div className="featured-header">
          <div className="featured-header-inner">
            <h2 className="featured-title">Our Services</h2>
            <p className="featured-subtitle">
              Cosmetic & Aesthetic Care with Advanced Treatments
            </p>
          </div>
        </div>

        <div className="container">
          <div class="services-grid">
            <div class="service-box">
              <h3>Laser & Skin Care</h3>
              <ul>
                <li>Laser Hair Removal</li>
                <li>Birthmarks Treatment</li>
                <li>Freckles & Sun Spots</li>
                <li>Tattoo Removal</li>
                <li>Moles & Warts Removal</li>
                <li>Rosacea Treatment</li>
                <li>Spider Veins</li>
              </ul>
            </div>
            <div class="service-box">
              <h3>Cosmetology & Aesthetics</h3>
              <ul>
                <li>Acne Treatment</li>
                <li>Skin Rejuvenation</li>
                <li>Under Eye Dark Circles</li>
                <li>Fillers</li>
                <li>Chemical Peels</li>
                <li>Pigmentation</li>
                <li>Skin Polishing</li>
                <li>Anti-Aging</li>
                <li>Vitiligo</li>
                <li>Psoriasis</li>
              </ul>
            </div>
            <div class="service-box">
              <h3>Advanced Treatments</h3>
              <ul>
                <li>Injectables</li>
                <li>Mesotherapy</li>
                <li>Botox & Fillers</li>
                <li>Hyperhidrosis</li>
                <li>PRP Therapy</li>
                <li>Customized Wigs & Hair Extension</li>
              </ul>
            </div>
            <div class="service-box">
              <h3>Surgical & Body Care</h3>
              <ul>
                <li>Hair Loss Treatment</li>
                <li>Hair Transplant</li>
                <li>Weight Loss</li>
                <li>Body Shaping</li>
                <li>Liposuction</li>
                <li>Tummy Tuck</li>
                <li>Gynecomastia</li>
                <li>Breast Augmentation & Reduction</li>
                <li>Nose Reshaping</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
